export default __webpack_public_path__ + "static/pic05-816ca2239c17de5eb9137799529c2322.jpg";